import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 15000,
});

export const getTrailers = () => api.get('/trailers').then((r) => r.data);

export const getTrailer = (id) => api.get(`/trailers/${id}`).then((r) => r.data);

export const getBookedDates = (id) =>
  api.get(`/trailers/${id}/booked-dates`).then((r) => r.data);

export const createBooking = (payload) => api.post('/bookings', payload).then((r) => r.data);

// admin
export const verifyAdmin = (token) =>
  api.post('/admin/verify', null, { headers: { 'X-Admin-Token': token } }).then((r) => r.data);

export const listBookings = (token) =>
  api.get('/admin/bookings', { headers: { 'X-Admin-Token': token } }).then((r) => r.data);

export const getStats = (token) =>
  api.get('/admin/stats', { headers: { 'X-Admin-Token': token } }).then((r) => r.data);

export const updateBookingStatus = (token, id, status) =>
  api
    .patch(`/admin/bookings/${id}`, { status }, { headers: { 'X-Admin-Token': token } })
    .then((r) => r.data);

export const deleteBooking = (token, id) =>
  api.delete(`/admin/bookings/${id}`, { headers: { 'X-Admin-Token': token } }).then((r) => r.data);

const adm = (token) => ({ headers: { 'X-Admin-Token': token } });

export const getAvailability = (token) => api.get('/admin/availability', adm(token)).then((r) => r.data);

export const setTrailerAvailability = (token, id, available) =>
  api.patch(`/admin/trailers/${id}/availability`, { available }, adm(token)).then((r) => r.data);

export const createBlock = (token, payload) => api.post('/admin/blocks', payload, adm(token)).then((r) => r.data);

export const deleteBlock = (token, id) => api.delete(`/admin/blocks/${id}`, adm(token)).then((r) => r.data);
